import { getItem } from '../utils/store'

export const data = [
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1059',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 1,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1051',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1052',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1053',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1054',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1055',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1056',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1057',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1058',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1069',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1061',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1062',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads/2016-03-25/56f5076ae947a.jpg',
    id: '1063',
    name: '优衣库：UNIQLO 2016校园招聘 | 有梦想、有热情、敢于挑战',
    status: 2,
    wxurl: '/cases/201603/yykuni.html'
  },
  {
    fengpi: 'Uploads3/201802/151781557255733.jpg',
    id: '4864',
    name: '平安银行：今天，是你未来的第一天',
    status: 1,
    wxurl: '/cases/201802/pingan.html'
  }
]

export function getData () {
  const keys = Object.keys(localStorage).filter((item) => /\d/.test(item) && getItem(item))
  const items = keys.map((id) => {
    return getItem(Number.parseInt(id))
  })
  return items.sort((a, b) => b.time - a.time)
}



// WEBPACK FOOTER //
// ./src/utils/mock.js